import PropTypes from 'prop-types';
import moment from 'moment';
import classNames from 'classnames';
import CellTooltip from './CellTooltip';

function TimestampCell({
  className = '',
  style = {},
  time = null,
  format = 'YYYY-MM-DD HH:mm:ss',
}) {
  if (!time) {
    // No time to compare to
    return null;
  }

  const timestamp = new moment(time).format(format);

  return (
    <CellTooltip title={timestamp}>
      <div
        className={classNames('TimestampCell', className)}
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          ...style,
        }}
      >
        {timestamp}
      </div>
    </CellTooltip>
  );
}

TimestampCell.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  /** Timestamp to parse */
  time: PropTypes.string,
  /** Custom format of date/time */
  format: PropTypes.string,
};

export default TimestampCell;
